import type { Observable } from 'rxjs';

import type { AgoInfo } from '~/domain';

import { useBackendHttpService } from '../../http';

const API = 's/ago/v1';

export function fetchOnlineHelpInfo(): Observable<AgoInfo> {
	const { http } = useBackendHttpService();
	return http.get(`${API}/token`);
}
